import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ContainerData, LabelData } from "./movementForm.style";

const MovementView = (props) => {
  const { entryLocation, dataBatch, stock, confirm } = props;
  const { t } = useTranslation();

  return (
    <>
      <div className="row justify-content-center mt-4 mt-md-5">
        <div className="col-12 col-md-11">
          <h3 className="title">{t(`forms.process.activity`)}</h3>
        </div>
      </div>
      <div className="row justify-content-center mt-4">
        <div className="col-11">
          <ContainerData>
            <div className="row">
              <div className="col-12">
                <LabelData>{t(`forms.process.labels.movOutPoint`)}:</LabelData>
                {t(`point.entry.${stock.locationStorageCode.toLowerCase()}`, {
                  code: stock.locationStorageCode.toLowerCase(),
                })}
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <LabelData>{t(`forms.process.labels.movPoint`)}:</LabelData>
                {t(entryLocation.name, { code: entryLocation.code })}
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <LabelData>{t(`forms.process.labels.outBatch`)}:</LabelData>
                {dataBatch.outBatch}
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <LabelData>{t(`forms.auxItems.labels.itemCode`)}:</LabelData>
                {dataBatch.itemCode}
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <LabelData>{t(`forms.process.labels.outWeight`)}:</LabelData>
                {dataBatch.outWeight}Kg
              </div>
            </div>
          </ContainerData>
        </div>
      </div>
      <div className="row justify-content-center mt-4">
        <div className="col-11">
          <button
            type="button"
            className="btn btn-primary w-100"
            onClick={() => confirm()}
          >
            {t("forms.process.buttons.confirmMovement")}
          </button>
        </div>
      </div>
    </>
  );
};
export default MovementView;
